import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {DefaultEntityLanding} from '@catcore/shared/default-entity-landing';
import {GenericLinkedResource} from '@catcore/types/base';
import {genericResourceToLinkItem, sortByLabelFunc} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ProjectUnitsService} from '@catmodules/models/project-units/services/project-units.service';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {ModifyServiceComponent} from '@catmodules/models/services/components/modify-service/modify-service.component';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {LinkItem, StyleType} from '@catui/types';
import {Subscription} from 'rxjs/Subscription';
import {isNullOrUndefined} from 'util';

const EntitySchemaTypeRef = 'ProjectUnits';
const selfTitle = 'Project Units';

@Component({
  templateUrl: './project-unit-landing.component.html',
  styleUrls: ['./project-unit-landing.component.scss'],
})
export class ProjectUnitLandingComponent extends DefaultEntityLanding<ProjectUnit> implements OnInit {

  linkedServices: LinkItem[] = [];
  unitSubscription: Subscription;

  styleType = StyleType;

  private currentResourceService;

  constructor(
    schemaService: EntitySchemaService,
    private unitService: ProjectUnitsService,
    private genericService: GenericResourceService,
    private modalService: ModalService,
  ) {
    super(schemaService);
    this.setSelfTitle(selfTitle);
  }

  ngOnInit() {
  }

  protected onEntityReceived(unit: ProjectUnit) {
    this.currentResourceService = this.genericService.findServiceForResource(this.resourceUri);

    const services = this.unitService.extractServicesFor(unit);
    this.linkedServices = genericResourceToLinkItem(services, (value: GenericLinkedResource) => (router: Router) => this.openModifyServiceDialog(value));
    this.linkedServices.sort(sortByLabelFunc);
  }

  private refreshResource() {
    this.currentResourceService.refresh();
  }

  private openModifyServiceDialog(serviceResource: GenericLinkedResource) {
    this.openDialog(serviceResource, (unit) => this.serviceModalFactory(unit));
  }

  private serviceModalFactory(serviceEntity) {
    const compRef = this.modalService.open(ModifyServiceComponent);
    compRef.componentInstance.serviceEntity = serviceEntity;
    compRef.componentInstance.enableDelete = false;
    compRef.componentInstance.afterUpdate.subscribe((updatedUnit) => this.refreshResource());
    compRef.componentInstance.afterDelete.subscribe((updatedUnit) => this.refreshResource());
    return compRef;
  }

  private openDialog(resource: GenericLinkedResource, componentFactory) {
    let compRef;
    const onFullfill = () => {
      resourceHandler.refresh();
      this.unitSubscription.unsubscribe();
    };

    const onError = () => {
      this.unitSubscription.unsubscribe();
    };

    const resourceHandler = this
      .genericService
      .findServiceForResource(resource.href);

    this.unitSubscription = resourceHandler
      .loadAndGet()
      .subscribe((item) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(item)) {
          compRef = null;
        } else {
          compRef = componentFactory(item);
          compRef.result.then(onFullfill, onError);
        }
      });
  }

  getEntitySchemaTypeRef() {
    return EntitySchemaTypeRef;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/landing-pages/project-unit-landing/project-unit-landing.component.ts